export default "__VITE_ASSET__HG4nKT_g__"